var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"mousedown":_vm.down,"touchstart":_vm.down,"mouseup":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }